import { render } from "./EditAnnouncementDialog.vue?vue&type=template&id=1d76acd4&scoped=true"
import script from "./EditAnnouncementDialog.vue?vue&type=script&lang=js"
export * from "./EditAnnouncementDialog.vue?vue&type=script&lang=js"

import "./EditAnnouncementDialog.vue?vue&type=style&index=0&id=1d76acd4&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1d76acd4"]])

export default __exports__